import React from "react";
import Helmet from "react-helmet";

// Temporary redirect — remove when /explore is ready to launch again.
// Netlify serves a 302 via public/_redirects; this page is a static fallback.
export default () => (
  <Helmet>
    <meta
      httpEquiv="refresh"
      content="0;url=https://fifreight.com/freight-hours"
    />
    <link rel="canonical" href="https://fifreight.com/freight-hours" />
  </Helmet>
);
